export const sv = {
  errSubmitQuote: 'Kunde inte skicka offert',
  notFound: 'Förfrågan hittades inte',
  backToRequests: 'Tillbaka till förfrågningar',
  title: 'Förfrågan',
  received: 'Mottagen {date}',
  cancelled: 'Avbruten',
  cancelledTitle: 'Kunden har avbrutit förfrågan',
  cancelledBody:
    'Förfrågan är inte längre aktiv. Du ser den här eftersom du redan har skickat en offert, men du kan inte längre skicka eller uppdatera offerter.',
  extraServices: 'Önskade tillval',
  extraServicesHint: 'Kunden har bett om det här utöver besiktningsanmärkningarna.',
  extraServicesPrefilled: 'Tillvalen är förifyllda som rader — sätt pris på dem.',
  noNote: 'Ingen beskrivning',
  vehicleInfo: 'Fordonsinformation',
  makeModel: 'Märke & modell',
  regNumber: 'Registreringsnummer',
  year: 'Årsmodell',
  unknown: 'Okänt',
  kommun: 'Kommun',
  inspectionReport: 'Besiktningsprotokoll',
  clickImageFullSize: 'Klicka på bilden för att öppna i full storlek',
  openImage: 'Öppna bild',
  reportedIssues: 'Påpekade fel',
  noIssues: 'Inga specifika fel har angivit. Besiktningsprotokoll kan finnas bifogat.',
  description: 'Beskrivning',
  actions: 'Åtgärder',
  quoteSent: 'Offert skickad',
  alreadySentQuote: 'Ni har redan skickat en offert på {price}',
  updateQuote: 'Uppdatera offert',
  sendQuote: 'Skicka offert',
  yourQuotes: 'Era offerter',
  inclVat: 'inkl. moms',
  workOrderColon: 'Arbetsorder:',
  sentAt: 'Skickad {date}',
  noQuotesSent: 'Inga offerter skickade än',
  clickSendQuoteHint: 'Klicka på "Skicka offert" för att skicka en offert',
  cancel: 'Avbryt',
  update: 'Uppdatera',
  workOrder: 'Arbetsorder',
  addRow: 'Lägg till rad',
  descriptionPlaceholder: 'Beskrivning (t.ex. Oljebyte)',
  quantityPlaceholder: 'Antal',
  unitPricePlaceholder: 'Pris/st (inkl. moms)',
  noWorkOrders: 'Inga arbetsorder tillagda än.',
  clickAddRowHint: 'Klicka på "Lägg till rad" för att lägga till arbetsorder.',
  priceLabel: 'Pris ({currency}, inkl. moms)',
  pricePlaceholder: 't.ex. 12500',
  messageLabel: 'Meddelande (valfritt)',
  messagePlaceholder: 'Beskriv vad som ingår i offerten...',
}

export const en: typeof sv = {
  errSubmitQuote: 'Could not submit the quote',
  notFound: 'Request not found',
  backToRequests: 'Back to requests',
  title: 'Request',
  received: 'Received {date}',
  cancelled: 'Cancelled',
  cancelledTitle: 'The customer has cancelled the request',
  cancelledBody:
    'The request is no longer active. You can see it here because you have already submitted a quote, but you can no longer submit or update quotes.',
  extraServices: 'Requested add-ons',
  extraServicesHint: 'The customer asked for these on top of the inspection remarks.',
  extraServicesPrefilled: 'The add-ons are pre-filled as rows — set a price for them.',
  noNote: 'No description',
  vehicleInfo: 'Vehicle information',
  makeModel: 'Make & model',
  regNumber: 'Registration number',
  year: 'Model year',
  unknown: 'Unknown',
  kommun: 'Municipality',
  inspectionReport: 'Inspection report',
  clickImageFullSize: 'Click the image to open it at full size',
  openImage: 'Open image',
  reportedIssues: 'Reported faults',
  noIssues: 'No specific faults have been listed. An inspection report may be attached.',
  description: 'Description',
  actions: 'Actions',
  quoteSent: 'Quote submitted',
  alreadySentQuote: 'You have already submitted a quote for {price}',
  updateQuote: 'Update quote',
  sendQuote: 'Submit quote',
  yourQuotes: 'Your quotes',
  inclVat: 'incl. VAT',
  workOrderColon: 'Work order:',
  sentAt: 'Sent {date}',
  noQuotesSent: 'No quotes submitted yet',
  clickSendQuoteHint: 'Click "Submit quote" to submit a quote',
  cancel: 'Cancel',
  update: 'Update',
  workOrder: 'Work order',
  addRow: 'Add row',
  descriptionPlaceholder: 'Description (e.g. Oil change)',
  quantityPlaceholder: 'Quantity',
  unitPricePlaceholder: 'Price/unit (incl. VAT)',
  noWorkOrders: 'No work order rows added yet.',
  clickAddRowHint: 'Click "Add row" to add work order rows.',
  priceLabel: 'Price ({currency}, incl. VAT)',
  pricePlaceholder: 'e.g. 12500',
  messageLabel: 'Message (optional)',
  messagePlaceholder: 'Describe what is included in the quote...',
}
